import { render, staticRenderFns } from "./BlocksTab.vue?vue&type=template&id=461f15ee&scoped=true"
import script from "./BlocksTab.vue?vue&type=script&lang=js"
export * from "./BlocksTab.vue?vue&type=script&lang=js"
import style0 from "./BlocksTab.vue?vue&type=style&index=0&id=461f15ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f15ee",
  null
  
)

export default component.exports